import gql from "graphql-tag";

export const GET_STATE = gql`
  query getState(
    $parentId: String
    $productFinderId: String
    $answers: String
  ) {
    state(
      parentId: $parentId
      productFinderId: $productFinderId
      answers: $answers
    ) {
      id
      page {
        title
        content
        questions {
          title
          description
          answers {
            id
            title
            description
            image
          }
          questionType {
            name
          }
        }
      }
      productFinder {
        image
        font {
          fontName
          fontSize
          fontWeight
        }
        colors {
          contentWrapperBgColor
          buttonPrimaryColor
          buttonPrimaryBackgroundColor
          buttonSecondaryColor
          buttonSecondaryBorderColor
          buttonTextColor
          buttonTextColorBorderColor
          buttonProductColor
          buttonProductBackgroundColor
          descriptionColor
          descriptionBackgroundColor
          headlineColor
          dropdownQuestionColor
          progressBarColor
          progressBarBackgroundColor
          progressBarLabelColor
          inputTextBoxBackgroundColorActive
          inputTextBoxBackgroundColorInactive
          inputTextBoxColorActive
          inputTextBoxColorInactive
          inputImageTextBoxBackgroundColorActive
          inputImageTextBoxBackgroundColorInactive
          inputImageTextBoxColorActive
          inputImageTextBoxColorInactive
          ratingColor
          ratingIconSize
          topProductBadgeColor
          topProductBadgeBackgroundColor
          errorMessageColor
          errorMessageBackgroundColor
        }
        config {
          onClickQuestions
          ratingsEnabled
          currency
          currencyFormat
          productImageMode
        }
      }
      step
      maxSteps
    }
  }
`;
